import {
  FreeLink as LibFreeLink,
  pickFreeLinkSettings
} from '@elfsight/widget-free-link';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../meta';

export function FreeLink() {
  const settings = useSettings();
  const freeLinkSettings = pickFreeLinkSettings(settings);

  return (
    <LibFreeLink
      {...freeLinkSettings}
      appName={meta.name}
      appAlias={meta.alias}
      style={{
        link: {
          marginTop: '20px'
        }
      }}
    />
  );
}
